// @core/api/endpoints/knowledge/remove_source.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/knowledge';

/**
 * Remove source
 * Removes a source from a knowledge base together with its chunks. The source's content (e.g. the document) is not touched.
 */
export async function RemoveSource(
  base_id: string,
  source_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/knowledge/bases/:base_id/sources/:source_id`;
  requestPath = requestPath.replace(':base_id', encodeURIComponent(base_id));
  requestPath = requestPath.replace(':source_id', encodeURIComponent(source_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
